import { render, staticRenderFns } from "./Political.vue?vue&type=template&id=6b28c4b8&"
import script from "./Political.vue?vue&type=script&lang=js&"
export * from "./Political.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports